import { i18n } from '@fs/zion-locale'

export default {
  activeHeader: () => i18n.t('searchResultsColumns.activeHeader', 'Availability Status'),
  actions: () => i18n.t('searchResultsColumns.actions', 'Actions'),
  ancestors: () => i18n.t('searchResultsColumns.ancestors', 'First Ancestors'),
  ancestralHall: () => i18n.t('searchResultsColumns.ancestralHall', 'Ancestral Hall'),
  archivalReferenceNumber: () => i18n.t('searchResultsColumns.archivalReferenceNumber', 'Archival Reference Number'),
  authors: () => i18n.t('searchResultsColumns.author', 'Author'),
  cameraOperator: () => i18n.t('searchResultsColumns.cameraOperator', 'Camera Operator'),
  captureDate: () => i18n.t('searchResultsColumns.captureDate', 'Capture Date'),
  childGroupCount: () => i18n.t('searchResultsColumns.childGroupCount', 'Child Group Count'),
  clanBranches: () => i18n.t('searchResultsColumns.clanBranch', 'Clan Branches'),
  clans: () => i18n.t('searchResultsColumns.clan', 'Clans'),
  creator: () => i18n.t('searchResultsColumns.creator', 'Creator'),
  custodian: () => i18n.t('searchResultsColumns.custodian', 'Custodian'),
  dateCreated: () => i18n.t('searchResultsColumns.dateCreated', 'Date Created'),
  dateRange: () => i18n.t('searchResultsColumns.dateRange', 'Date'),
  dgsNumber: () => i18n.t('searchResultsColumns.dgsNumber', 'Image Group Number'),
  groupId: () => i18n.t('searchResultsColumns.groupId', 'Group ID'),
  imageRework: () => i18n.t('searchResultsColumns.imageRework', 'Image Rework'),
  images: () => i18n.t('searchResultsColumns.images', 'Images'),
  imagesIndexed: () => i18n.t('searchResultsColumns.imagesIndexed', 'Images Indexed'),
  indexStatus: () => i18n.t('searchResultsColumns.indexStatus', 'Index Status'),
  language: () => i18n.t('searchResultsColumns.language', 'Language'),
  mediaNumber: () => i18n.t('searchResultsColumns.mediaNumber', 'Media Number'),
  migrantAncestor: () => i18n.t('searchResultsColumns.migrantAncestor', 'Migrant Ancestor'),
  naturalGroupId: () => i18n.t('searchResultsColumns.naturalGroupId', 'Natural Group ID'),
  captureId: () => i18n.t('searchResultsColumns.captureId', 'Capture ID'),
  numberOfImages: () => i18n.t('searchResultsColumns.numberOfImages', 'Number of Images'),
  places: () => i18n.t('searchResultsColumns.place', 'Place'),
  projectId: () => i18n.t('searchResultsColumns.projectId', 'Project ID'),
  publicationYear: () => i18n.t('searchResultsColumns.publicationYear', 'Publication Year'),
  recordType: () => i18n.t('searchResultsColumns.recordType', 'Record Type'),
  title: () => i18n.t('searchResultsColumns.title', 'Title'),
  titleNumber: () => i18n.t('searchResultsColumns.titleNumber', 'Title Number'),
  totalVolumes: () => i18n.t('searchResultsColumns.totalVolumes', 'Total Volumes'),
  volumes: () => i18n.t('searchResultsColumns.volume', 'Volume'),
  weekEndingDate: () => i18n.t('searchResultsColumns.weekEndingDate', 'Week Ending Date'),
}
